
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/why-we-dont-sell-better-grades",
      function () {
        return require("private-next-pages/articles/why-we-dont-sell-better-grades.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/why-we-dont-sell-better-grades"])
      });
    }
  